var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLaneDepartureWarning32 = function SvgLaneDepartureWarning32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.683 6.6 2.286.867a4.143 4.143 0 0 1 2.406 5.343l-4.293 11.325a3.48 3.48 0 0 1-4.488 2.02l-3.526-1.336a3.48 3.48 0 0 1-2.02-4.488L16.34 9.006A4.143 4.143 0 0 1 21.683 6.6Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.615 11.676 2.566.972a4.008 4.008 0 0 1 2.327 5.169l-1.635 4.313a1.093 1.093 0 0 1-1.41.635l-8.017-3.039a1.093 1.093 0 0 1-.635-1.41l1.64-4.327a4.009 4.009 0 0 1 5.164-2.313v0Zm-4.81 1.32-2.401-.911m14.866 5.637-2.4-.911",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 2v28",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.82 4.37 1.82 4.37 1.82 4.37"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 18v12m0-28v6",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgLaneDepartureWarning32;